import * as active from './host-config/active';

const Config = active;

export default Config;
